import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ConfirmationPage() {
  const navigate = useNavigate();
  const [showCheck, setShowCheck] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowCheck(true);
    }, 200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col overflow-x-hidden">
      {/* NAVBAR */}
      <nav className="bg-blue-600 text-white px-4 sm:px-6 py-4 relative z-50">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">
          {/* LOGO */}
          <div className="flex justify-center lg:justify-start items-center">
            <img
              src="/Logo.svg"
              alt="Logo"
              className="h-14 sm:h-20 lg:h-24 w-auto max-w-[220px] sm:max-w-[300px] lg:max-w-[380px] object-contain block"
            />
          </div>

          {/* MENU */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 lg:gap-6">
            <button
              className="w-full sm:w-auto px-4 py-2 bg-blue-700/60 rounded-full text-base sm:text-lg lg:text-[20px] hover:bg-white/30 transition"
              onClick={() => navigate("/")}
            >
              Accueil
            </button>

            <button
              className="w-full sm:w-auto px-4 py-2 bg-blue-700/60 rounded-full text-base sm:text-lg lg:text-[20px] hover:bg-white/30 transition"
              onClick={() => navigate("/devis")}
            >
              Devis
            </button>

            <button className="w-full sm:w-auto px-4 py-2 bg-blue-700/60 rounded-full text-base sm:text-lg lg:text-[20px] hover:bg-white/30 transition-colors">
              Avis
            </button>
          </div>

          {/* CONTACT */}
          <div className="flex items-center justify-center lg:justify-end">
            <div className="flex flex-col items-center">
              <button className="bg-red-500 px-4 py-2 rounded-md font-bold text-white text-sm sm:text-base">
                07 66 11 91 93
              </button>
              <span className="mt-1 text-xs sm:text-sm">Assistant client</span>
            </div>
          </div>
        </div>
      </nav>

      {/* CONTENU */}
      <main className="flex flex-col items-center justify-center flex-1 text-center px-4 sm:px-6 py-10">
        <div className="w-full max-w-2xl">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
            Merci pour votre demande !
          </h1>

          <p className="text-base sm:text-lg text-gray-700 max-w-xl mx-auto leading-relaxed">
            Votre devis a bien été transmis.
            <br className="hidden sm:block" />
            Vous recevrez une réponse personnalisée dans les prochaines minutes.
          </p>

          {/* CHECKMARK SVG ANIMÉ */}
          <div
            className={[
              "w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 mx-auto mt-8",
              "transition-all duration-700 ease-out transform",
              showCheck ? "opacity-100 scale-100" : "opacity-0 scale-50",
            ].join(" ")}
          >
            <svg viewBox="0 0 52 52" className="w-full h-full">
              <circle
                cx="26"
                cy="26"
                r="25"
                fill="none"
                stroke="#22c55e"
                strokeWidth="4"
              />
              <path
                fill="none"
                stroke="#22c55e"
                strokeWidth="6"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M14 27 l8 8 l16 -18"
              />
            </svg>
          </div>

          <p className="text-sm sm:text-base text-gray-500 mt-4">
            Merci de votre confiance.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={() => navigate("/")}
              className="w-full sm:w-auto px-6 py-3 rounded-md bg-blue-600 text-white font-semibold hover:bg-blue-700 transition"
            >
              Retour à l&apos;accueil
            </button>

            <button
              onClick={() => navigate("/devis")}
              className="w-full sm:w-auto px-6 py-3 rounded-md border border-gray-300 text-gray-700 font-semibold bg-white hover:bg-gray-50 transition"
            >
              Faire une autre demande
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}